import { FilterInputTypes, IFilterInput } from '../shared/interfaces/filter-input.interface';

export const filterInputs: IFilterInput[] = [
  {
    resultLabel: 'Periods',
    type: FilterInputTypes._dropdown,
    placeholder: 'Periods',
    controlName: 'PeriodsId',
    optionLabel: 'label',
    clearable: true,
    enableFilters: true,
    options: [],
    permissionKey: 'hasPeriodFilterPermission'
  },
  {
    resultLabel: 'Service Region',
    type: FilterInputTypes._dropdown,
    hasVirtualScroll: true,
    placeholder: 'Service Region',
    controlName: 'ServiceRegionId',
    optionLabel: 'label',
    clearable: true,
    enableFilters: true,
    options: [],
    permissionKey: 'hasServiceRegionFilterPermission'
  },
  {
    resultLabel: 'Service Area',
    type: FilterInputTypes._dropdown,
    hasVirtualScroll: true,
    hasGroup: true,
    placeholder: 'Service Area',
    controlName: 'ServiceAreaId',
    optionLabel: 'label',
    clearable: true,
    enableFilters: true,
    options: [],
    permissionKey: 'hasServiceAreaFilterPermission'
  },
  {
    resultLabel: 'Status',
    type: FilterInputTypes._dropdown,
    placeholder: 'Status',
    controlName: 'StatusId',
    optionLabel: 'label',
    clearable: true,
    enableFilters: true,
    options: [],
    permissionKey: 'hasStatusFilterPermission'
  },
  {
    resultLabel: 'Passenger',
    type: FilterInputTypes._dropdown,
    hasVirtualScroll: true,
    placeholder: 'Passenger',
    controlName: 'PassengerId',
    optionLabel: 'label',
    clearable: true,
    enableFilters: true,
    options: [],
    permissionKey: 'hasPassengerFilterPermission'
  },
  {
    resultLabel: 'Ride With Notes',
    label: 'Ride With Notes',
    type: FilterInputTypes._checkbox,
    controlName: 'RideWithNotes',
    permissionKey: 'hasRidesWithNotesPermission'
  },
  {
    resultLabel: 'Ride number',
    type: FilterInputTypes._dropdown,
    hasVirtualScroll: true,
    placeholder: 'Ride Number',
    controlName: 'OriginalRideId',
    optionLabel: 'label',
    clearable: true,
    enableFilters: true,
    options: [],
    permissionKey: 'hasRideIdFilterPermission'
  },
  {
    resultLabel: 'Equipments Need',
    type: FilterInputTypes._dropdown,
    hasVirtualScroll: true,
    placeholder: 'Equipments Need',
    controlName: 'EquipmentsNeed',
    optionLabel: 'label',
    clearable: true,
    enableFilters: true,
    options: [],
    permissionKey: 'hasEquipmentsNeedFilterPermission'
  },
  {
    resultLabel: 'Place',
    type: FilterInputTypes._dropdown,
    hasVirtualScroll: true,
    placeholder: 'Place',
    controlName: 'PlaceId',
    optionLabel: 'label',
    clearable: true,
    enableFilters: true,
    options: [],
    permissionKey: 'hasPlaceFilterPermission'
  },
  {
    resultLabel: 'State',
    type: FilterInputTypes._dropdown,
    hasVirtualScroll: false,
    placeholder: 'State',
    controlName: 'State',
    optionLabel: 'label',
    clearable: true,
    enableFilters: true,
    options: [],
    permissionKey: 'hasStateFilterPermission'
  },
  {
    resultLabel: 'Contractor',
    type: FilterInputTypes._dropdown,
    hasVirtualScroll: true,
    placeholder: 'Contractor',
    controlName: 'PartnersId',
    optionLabel: 'label',
    clearable: true,
    enableFilters: true,
    options: [],
    permissionKey: 'hasContractorFilterPermission'
  },

  {
    resultLabel: 'Client',
    type: FilterInputTypes._dropdown,
    hasVirtualScroll: true,
    placeholder: 'Client',
    controlName: 'ClientId',
    optionLabel: 'label',
    clearable: true,
    enableFilters: true,
    options: [],
    permissionKey: 'hasClientFilterPermission'
  },
  {
    resultLabel: 'Clients',
    type: FilterInputTypes._multiSelect,
    hasVirtualScroll: true,
    placeholder: 'Client',
    controlName: 'ClientIds',
    optionLabel: 'label',
    clearable: true,
    enableFilters: true,
    options: [],
    permissionKey: 'hasMultiClientFilterPermission'
  },
  {
    resultLabel: 'Show All',
    label: 'Show All',
    type: FilterInputTypes._checkbox,
    controlName: 'ShowAll',
    permissionKey: 'hasShowAllFilterPermission'
  },
  {
    resultLabel: 'Provider',
    type: FilterInputTypes._dropdown,
    hasGroup: true,
    placeholder: 'Driver Provider',
    controlName: 'Provider',
    optionLabel: 'label',
    clearable: true,
    hasVirtualScroll: true,
    enableFilters: true,
    options: [],
    permissionKey: 'hasDriverProviderFilterPermission'
  },

  {
    resultLabel: 'From Time',
    type: FilterInputTypes._time,
    controlName: 'FromTime',
    placeholder: 'From Time',
    permissionKey: 'hasFromTimeFilterPermission'
  },
  {
    resultLabel: 'To Time',
    type: FilterInputTypes._time,
    controlName: 'ToTime',
    placeholder: 'To Time',
    permissionKey: 'hasToTimeFilterPermission'
  },
  {
    resultLabel: 'Equipments',
    type: FilterInputTypes._multiSelect,
    hasVirtualScroll: true,
    placeholder: 'Equipments',
    controlName: 'EquipmentsType',
    optionLabel: 'label',
    clearable: true,
    enableFilters: true,
    options: [],
    permissionKey: 'hasEquipmentsFilterPermission'
  },
  {
    resultLabel: 'Cancellation Reasons',
    type: FilterInputTypes._multiSelect,
    hasVirtualScroll: true,
    placeholder: 'Cancellation Reasons',
    controlName: 'CancellationReasons',
    optionLabel: 'label',
    clearable: true,
    enableFilters: true,
    options: [],
    permissionKey: 'hasCancellationReasonFilterPermission'
  },
];
